import {SoopLoading, SoopPagination} from '@soop-ui/soop-ui';
import {Faq} from '@/api/help/faq/type';
import {useExpandedFaq} from '@/hooks/help';
import {FaqBoardPcProps} from '@/components/help/common/FaqBoard';
import FaqItem from '@/components/help/common/FaqBoard/FaqItem';
import EmptyBoard from '@/components/help/common/EmptyBoard';
import styles from './FaqBoard.module.scss';

const FaqBoard = ({type, data, isLoading, onPageChange}: FaqBoardPcProps) => {
  const {expandedId, setExpandedId} = useExpandedFaq();
  const faqList = data?.faqList || [];
  const totalPages = data?.totalPages || 0;
  const currentPage = data?.currentPage || 0;

  return isLoading ? (
    // 임시
    <SoopLoading />
  ) : faqList.length === 0 ? (
    <EmptyBoard type={type} />
  ) : (
    <div>
      <div className={styles.FaqListArea}>
        {faqList.map((item: Faq) => (
          <FaqItem
            key={item.kbId}
            item={item}
            isExpanded={expandedId === item.kbId}
            onExpand={() => setExpandedId(item.kbId)}
          />
        ))}
      </div>
      {Boolean(totalPages) && (
        <SoopPagination
          currentPage={currentPage}
          totalPages={totalPages}
          align='center'
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default FaqBoard;
